import React, { useState, useEffect, useRef } from "react";
import http from "../services/http";
import { ToastContainer } from "react-toastify";
import upload from "../assets/images/upload.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useParams, useNavigate } from "react-router-dom";
import HeaderLeft from "./HeaderLeft";
import DropdownRight from "./DropdownRight";

function ApplicantProfile() {
  const params = useParams();
  const { id } = params;

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [analystinfo, setAnalystinfo] = useState({});
  const [uploadSpin, setUploadSpin] = useState(false);

  const analyistInfo = async () => {
    setUploadSpin(true);

    http

      .get(`public/analyst/applicants/${id}`)
      .then((res) => {
        console.log("analyst ------->>>>", res.data);
        setAnalystinfo(res.data);
        setUploadSpin(false);
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const inputFileRef = useRef(null);
  const onBtnClick = () => {
    inputFileRef.current.click();
  };

  useEffect(() => {
    analyistInfo();
  }, []);
  const ViewBucket = () => {
    navigate(`/analystApplicantJohnDoe/${id}`);
  };

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification">
        <div className="login_inner custom_hight">
          <h1 className="mb_30 main_title ">{analystinfo.firstname}</h1>

          <div className="user_profile_eidte">
            {" "}
            <input type="file" ref={inputFileRef} style={{ display: "none" }} />
            <img
              alt="profile"
              src={upload}
              onClick={onBtnClick}
              style={{
                width: 150,
                height: 150,
                border: "1px solid gray",
                padding: 5,
                borderRadius: "50%",
              }}
            />
          </div>
          <Container>
            <Row className="justify-content-center">
              <Col lg="6">
                <Row className="mb-3">
                  <Col>Name</Col>
                  <Col>{analystinfo.firstname}</Col>
                </Row>
                <Row className="mb-3">
                  <Col>Email</Col>
                  <Col>{analystinfo.email}</Col>
                </Row>
                <Row className="mb-3">
                  <Col>CV</Col>
                  <Col>
                    {analyistInfo.cv ? (
                      <a href={analystinfo.cv} download>
                        Click to download
                      </a>
                    ) : (
                      "No cv"
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            type="submit"
            className="them_btn mt_40 mb_30"
            onClick={ViewBucket}
          >
            View Bucket
          </button>
        </div>
      </section>

      <ToastContainer />
    </>
  );
}

export default ApplicantProfile;
